<template>
  <div class="source-horizontal-filter ">
    <v-btn
      v-for="item in listSources"
      :key="`source-${item.id}`"
      :color="getBtnColor(item.id)"
      class="mb-2 source-horizontal-filter_item"
      large
      @click.prevent="setValue(item.id)"
    >
      {{ item.name }}
    </v-btn>
  </div>
</template>

<script>
  import SourceDataService from '@/services/api/SourceDataService'

  export default {
    name: 'SourceHorizontalFilter',
    props: {
      value: {
        type: [String, Number],
        default: null,
      },
      showAllBtn: {
        type: Boolean,
        default: true,
      },
      filialId: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        sources: [],
        listLoading: false,

      }
    },
    computed: {
      customItems () {
        const items = []

        if (this.showAllBtn) {
          items.push({ id: null, name: 'Все' })
        }

        items.push({ id: 'sushiset', name: 'Основное меню' })

        return items
      },
      listSources () {
        return [...this.customItems, ...this.sources]
      },
    },
    created () {
      this.loadSources()
    },
    methods: {
      async loadSources () {
        this.listLoading = true
        try {
          this.sources = await SourceDataService.all({ filialId: this.filialId })
        } catch (err) {
          this.showErrorFromResponse(err)
        }
        this.listLoading = false
      },
      getBtnColor (id) {
        return id === this.value ? 'primary' : '#fff'
      },
      setValue (id) {
        this.$emit('input', id)
      },
    },
  }
</script>

<style scoped lang="less">
.source-horizontal-filter {
  margin-bottom: 25px;
  display: flex;
  flex-wrap: wrap;

  &_item {
    margin-right: 10px;
    /*box-shadow: 0 2px 2px #00000029; */
    //border:  1px solid rgba(0, 0, 0, 0.2) !important;
    //box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.2);
    box-shadow: 0 3px 6px #00000029;
    border-radius: 0 10px 0 10px;

    @media (max-width: 1500px) {
      padding: 0 15px !important;
      min-width: 80px !important;
    }

    &__first {

    }

    &:last-child {
      margin-right: 0;
    }

    .media-sm({
      flex-basis: calc(50% - 10px);
    });
  }
}
</style>
